import { client, errorValidation } from "./service.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getSportCategoryOptions() {
  try {
    let response = await client.get(`/sport-categories`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;

    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getCourtTypeOptions({
  merchantId, placeId
}) {
  try {
    let response = await client.get(`/court-type-list?merchantId=${merchantId || ''}&placeId=${placeId || ''}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;

    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getSportCourtTypes(merchantId, placeId) {
  try {
    let response = await client.get(`/sport-court-types`, {
      params: {
        merchantId: merchantId,
        placeId: placeId
      }
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getSportCourtType(id) {
  try {
    let response = await client.get(`/sport-court-type/${id}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function createSportCourtType(body) {
  try {
    let response = await client.post(`/sport-court-type/create`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function updateSportCourtType(body) {
  try {
    let response = await client.post(`/sport-court-type/update`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function deleteSportCourtType(id) {
  try {
    let response = await client.delete(`/sport-court-type/delete/${id}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}